import { Component, OnInit } from '@angular/core';
import { AchooFilterBoxComponent } from '../../../../core/achoo-filter-box/achoo-filter-box.component';

@Component({
  selector: 'auto-group-filter-box',
  templateUrl: './auto-group-filter-box.component.html',
  styleUrls: ['./auto-group-filter-box.component.scss']
})
export class AutoGroupFilterBoxComponent extends AchooFilterBoxComponent implements OnInit {

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-filter-box/auto-group-filter-box.component.ts